/*
  This reducer really isn't necessary.
  We need it because we're using combineReducers.
  cid gets handed in as initialState from client.js.
  It comes from data added to index.html by the server.
 */
export default (state = 0) => state
